import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import features from 'lib/common/features';
import formattedDate from 'lib/common/formattedDate';
import includes from 'lodash/includes';
import find from 'lodash/find';
import get from 'lodash/get';

/**
 * Use value of web content field, otherwise
 * fallback to performance description.
 */
function displayTitle(description, webContent) {
    let customTitle = features.getOption('details', 'displayTitleWebContentId');
    if (customTitle) {
        let webContentField = find(webContent,
            field => parseInt(field.content_type, 10) === customTitle);
        return (webContentField) ? webContentField.content_value : description;
    } else {
        return description;
    }
}

function findAdditionalMessagesToDisplay(webContent) {
    let webContentDescriptions = features.getOption('details', 'additionalMessageWebContentDescriptions');
    if (webContent.length > 0 && webContentDescriptions && webContentDescriptions.length > 0) {
        return webContent.filter(function(entry) {
            return includes(webContentDescriptions, entry.content_type_desc);
        });
    } else {
        return [];
    }
}

const Details = props => {
    var perfDate = get(props, 'details.summary.perf_dt');
    var webContent = get(props, 'details.webContent', []);
    var facilityDescription = get(props, 'details.summary.facility_desc');
    var additionalMessagesToDisplay = findAdditionalMessagesToDisplay(webContent);

    return (
        <header className={classnames({
            'syos-performance-details': true,
            'syos-performance-details--empty': !props.details
        })}>
            <h2 className="syos-performance-details__title">{props.details && displayTitle(
                props.details.summary.description,
                props.details.webContent)
            }</h2>
            <h3 className="syos-performance-details__subtitle">
                {perfDate && (
                    <span className="syos-performance-details__date">
                        {formattedDate(perfDate)} at&ensp;
                    </span>
                )}
                <span className="syos-performance-details__facility">
                    {facilityDescription}
                </span>
            </h3>
            {additionalMessagesToDisplay.length > 0 && (
                <div className="syos-performance-details__additional-messages">
                    {additionalMessagesToDisplay.map((entry, key) => {
                        return (
                            <p key={key} className="syos-performance-details__additional-message">{entry.content_value}</p>
                        );
                    })}
                </div>
            )}
        </header>
    );
};
Details.propTypes = {
    details: PropTypes.object,
    isAvailable: PropTypes.bool.isRequired // eslint-disable-line react/no-unused-prop-types
};

export default Details;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/Details.js